import React from 'react'

const Referral = () => {
  return (
    <div>
      <h1>Comming Soon!</h1>
    </div>
  )
}

export default Referral
